module.exports = __webpack_public_path__ + "img/Twilight.a665ea8c.webp";